import React from "react";
import { Link } from "react-router-dom";
import useGet from "../../hooks/read/useGet";
import toast from "react-hot-toast";
import RoundedContainer from "../../components/containers/RoundedContainer";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";
import LinkButton from "../../components/ui/LinkButton";

const ListWFHEmployee = () => {
  const {
    list: applicationList,
    paramsObject,
    setGetListParams,
  } = useGet({
    url: "wfhApplicationList",
    onSuccess: () => {},
    onError: () => {
      toast.error(
        "There Was An Error While Fetching The Data Please Try Again Later"
      );
    },
  });
  function getDaysBetweenDates(fromDateTimestamp, toDateTimestamp) {
    // Convert the timestamps from seconds to milliseconds
    const fromDate = new Date(fromDateTimestamp * 1000);
    const toDate = new Date(toDateTimestamp * 1000);

    // Calculate the difference in milliseconds
    const timeDifference = toDate.getTime() - fromDate.getTime();

    // Convert the time difference to days
    const daysDifference = timeDifference / (1000 * 3600 * 24);

    // Return the number of days, rounded to the nearest whole number
    console.log(Math.round(daysDifference));

    return Math.round(daysDifference);
  }

  return (
    <div className="px-5 py-8">
      <RoundedContainer className=" my-5 text-right">
        <LinkButton to="/wfh/apply">Apply For Remote Work</LinkButton>
      </RoundedContainer>

      <RoundedContainer>
        <Table className="table-auto w-full">
          <TableHead>
            <TableHeaderCell className="w-[10%] text-center">
              Sr.No
            </TableHeaderCell>
            <TableHeaderCell className="w-[25%] text-center">
              Applied Date
            </TableHeaderCell>
            <TableHeaderCell className="w-[15%] text-center">
              Number of days
            </TableHeaderCell>
            <TableHeaderCell className="w-[20%] text-center">
              Status
            </TableHeaderCell>
            <TableHeaderCell className="w-[30%]">
              Reason
            </TableHeaderCell>
          </TableHead>
          <TableBody>
            {applicationList?.data?.data?.map((item, index) => (
              <TableRow key={index}>
                <TableCell className="text-center text-dark font-medium text-sm lg:text-base">
                  {index + 1}
                </TableCell>
                <TableCell className="text-center text-dark font-medium text-sm lg:text-base">
                  {new Date(item?.from_date * 1000).toLocaleDateString()}
                  <span> - </span>
                  {new Date(item?.to_date * 1000).toLocaleDateString()}
                </TableCell>
                <TableCell className=" text-center text-dark font-medium text-sm lg:text-base">
                  {getDaysBetweenDates(item?.from_date, item?.to_date)}
                </TableCell>
                <TableCell className="text-center text-dark font-medium text-sm lg:text-base">
                  {item.status === "1" ? (
                    <span className="text-green-600 bg-green-100 px-2 text-xs py-2 font-semibold rounded-md">
                      Approved
                    </span>
                  ) : item.status === "2" ? (
                    <span className="text-yellow-600 bg-yellow-100 px-2 text-xs py-2 font-semibold rounded-md">
                      Pending
                    </span>
                  ) : (
                    <span className="text-red-600 bg-red-100 px-2 text-xs py-2 font-semibold rounded-md">
                      Rejected
                    </span>
                  )}
                </TableCell>
                <TableCell className="text-center text-dark font-medium text-sm lg:text-base">
                  {item.reason}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {applicationList?.data?.data?.length === 0 && (
          <div className="text-center py-16">
            <p className="text-lg font-semibold text-gray-500">
              No remote work applications found
            </p>
          </div>
        )}
      </RoundedContainer>
    </div>
  );
};

export default ListWFHEmployee;
